'use client';
import styles from './styles.module.scss';

const SingleCircleGraph = ({title, percentFull, label, color}) => {

    const full = 628;
    const filled = full - (full * (percentFull *.01));
    return(
        <div className={`${styles.circleGraphs__graph} ${color[0]}`}>
            <svg width="230" height="230" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle 
                cx="115" 
                cy="115" 
                r="100" 
                stroke="#D1D1D1" 
                strokeWidth="23" 
                fill="none"
            />
            <circle 
                className={`${styles.circleGraphs__fill} ${color[0]}`}
                cx="115" 
                cy="115" 
                r="100" 
                stroke="#FF5733" 
                strokeWidth="23" 
                fill="none" 
                strokeDasharray={full} strokeDashoffset={filled}
                strokeLinecap="round" 
                transform="rotate(-90 115 115)"     
            />
              <text x="115" y="115" className={`${styles.circleGraphs__text} ${color[0]}`} textAnchor="middle" dominantBaseline="middle" fontSize="48" fill="#000000">
                {label}
            </text>
            </svg>
            <div className={`${styles.circleGraphs__title} ${color[0]}`}>
                {title}
            </div>
        </div>
    );
}

export default SingleCircleGraph;